import { createFileRoute } from '@tanstack/react-router'
import { requirePagePermission } from '~/features/org/guard'
import { PrivacyPage } from '~/features/gdpr/PrivacyPage'
import { PRIVACY_TABS, type PrivacySearch, type PrivacyTab } from '~/features/gdpr/search'
import { consentsQuery, documentsQuery } from '~/features/gdpr/queries'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const Route = createFileRoute('/_app/verein/datenschutz/')({
  beforeLoad: ({ context }) => requirePagePermission(context.queryClient, 'gdpr.manage'),
  // The tab lives in the URL, so back button and shared links land on it (v1 kept it in state).
  validateSearch: (s: Record<string, unknown>): PrivacySearch => ({
    ...(PRIVACY_TABS.includes(s.tab as PrivacyTab) && s.tab !== 'einwilligungen' ? { tab: s.tab as PrivacyTab } : {}),
    ...(typeof s.person === 'string' && UUID.test(s.person) ? { person: s.person } : {}),
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) =>
    Promise.all([
      queryClient.ensureQueryData(consentsQuery),
      deps.tab === 'dokumente' ? queryClient.ensureQueryData(documentsQuery(deps.person)) : null,
    ]),
  component: function Privacy() {
    return <PrivacyPage search={Route.useSearch()} />
  },
})
